import { ReactNode } from 'react';
import { Grid, Box } from '@simplywallst/ui-core';

import { Outer } from './styled';

interface Props {
  children: ReactNode;
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  'data-cy-id'?: string;
}

export const ValuationRow = ({
  children,
  selected,
  onClick,
  disabled,
  'data-cy-id': dataCyId,
}: Props) => {
  return (
    <Grid
      templateColumns="max-content 1fr max-content"
      justifyContent="space-between"
      backgroundColor="noir"
      borderRadius="x1"
      padding="x3"
      columnGap="16px"
      alignItems="center"
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      onClick={() => {
        onClick && !disabled && onClick();
      }}
      opacity={disabled ? 0.3 : 1}
      cursor={disabled ? 'not-allowed' : 'pointer'}
      data-cy-id={dataCyId}
    >
      {typeof selected !== 'undefined' && (
        <Box position="relative" width="16px" height="16px">
          <Outer selected={selected} />
          {selected && (
            <Box
              position="absolute"
              width="8px"
              height="8px"
              borderRadius="x0_5"
              backgroundColor="brand01"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
            />
          )}
        </Box>
      )}
      {children}
    </Grid>
  );
};
